module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/modal-profile-7-image-e26d18e31bc309fd219b98faf129db95.png";